import { ActivatedRoute } from '@angular/router';
import { NullValidationHandler, OAuthService } from 'angular-oauth2-oidc';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {DEFAULT_INTERRUPTSOURCES, Idle} from '@ng-idle/core';

import { NavigationService } from './services/navigation.service';
import { authCodeFlowConfig } from './auth.config';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

  title = 'CorHealth DCIS';
  timer: NodeJS.Timeout;
  userSessionWarning = false;
  countDown = {mins: 0, sec: 0};

  constructor(private oauthService: OAuthService,
              private navigationService: NavigationService,
              private router: ActivatedRoute,
              private userIdle: Idle,
              private cdr: ChangeDetectorRef) {
                userIdle.setIdle(environment.sessionInactiveSeconds);
                userIdle.setTimeout(environment.sessionTimeoutCountDownSeconds);
                userIdle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
                userIdle.onTimeout.subscribe(() => {
                  if (oauthService.hasValidAccessToken()) {
                    this.userSessionWarning = false;
                    this.navigationService.appLogout(false);
                  }
                });
                userIdle.onTimeoutWarning.subscribe(( countDown: number ) => {
                  if (oauthService.hasValidAccessToken()) {
                    sessionStorage.removeItem('sessionTimedOut');
                    this.countDown.mins =  Math.floor(countDown / 60);
                    this.countDown.sec = countDown % 60;
                    this.userSessionWarning = true;
                    // avoid development ExpressionChangedAfterItHasBeenCheckedError
                    this.cdr.detectChanges();
                  }
                });
                userIdle.onIdleEnd.subscribe(() => {
                  if (this.userSessionWarning) {
                    this.handleTimer(this.countDown);
                  }
                });
                this.userIdle.watch();
              }

  ngOnInit() {

    const url = window.location.href;
    const params = (new URLSearchParams(url));
    const errorInfo = params?.get('error_description');
    if (errorInfo?.includes('AADB2C90118')) {
      this.navigateToResetPasswordFlow();
    } else {
      this.configureOAuthService();
      this.oauthService.tryLoginCodeFlow().then(() => {
        if (!this.oauthService.hasValidAccessToken()){
          this.navigationService.navigateToLoginPage();
        }
      });

      // observe logout event in other tabs
      window.addEventListener('storage', (event) => {
        if (!event.url.includes(environment.redirectURI)) {
          return;
        }
        if (event.storageArea === localStorage) {  
          const token = localStorage.getItem('userLoggedIn');
          if (!token) {
            this.userSessionWarning = false;
            this.navigationService.appLogout(true);
          }
        }
      });
    }

  }

  public refreshUserSession() {
    this.userSessionWarning = false;
    clearInterval(this.timer);
  }

  private handleTimer(countDownObj: {mins: number, sec: number}) {
    let countDown = countDownObj.mins * 60 + countDownObj.sec;
    this.timer = setInterval(() => {
      countDown--;
      if (countDown <= 0) {
        clearInterval(this.timer); // Clear the timer
        this.logout();
      } else {
        this.countDown.mins = Math.floor(countDown / 60);
        this.countDown.sec = countDown % 60;
      }
      this.cdr.detectChanges();
    }, 1000);
  }

  private navigateToResetPasswordFlow() {
    const resetPasswordUrl = `${environment.azure_reset_password_URI}&nonce=defaultNonce&response_type=id_token&prompt=login` +
        `&client_id=${authCodeFlowConfig.clientId}` +
        `&redirect_uri=${authCodeFlowConfig.redirectUri}` +
        `&scope=openid`;
    window.location.href = resetPasswordUrl;
  }

  private configureOAuthService() {
    this.oauthService.configure(authCodeFlowConfig);
    this.oauthService.tokenValidationHandler = new NullValidationHandler();
    this.oauthService.loadDiscoveryDocument(environment.discoveryDocumentUrl);
    this.oauthService.setupAutomaticSilentRefresh();
  }

  logout() {
    // close modal popup
    this.userSessionWarning = false; 
    this.navigationService.appLogout(false);
  }
}
